import React, { FC } from "react";

import type { Product } from "@/services/productService/types";

import "./style.scss";

const ByNGetNOverlayTag: FC<{
  overlayTagLabel?: Product["overlayTagLabel"];
}> = ({ overlayTagLabel }) => {
  if (!overlayTagLabel?.label) return null;

  return (
    <span
      className="buy_n_get_n_overlay_tag"
      style={{
        color: overlayTagLabel.style?.textColor ?? "none",
        ...overlayTagLabel.style
      }}
      dangerouslySetInnerHTML={{ __html: overlayTagLabel.label }}
    />
  );
};

export default ByNGetNOverlayTag;
